import { useViewModel as useSharedViewModel } from './shared';

export const useViewModel = (props) => {
    const shared = useSharedViewModel(props);

    return {
        ...props,
        ...shared,
    };
};
